import { render, staticRenderFns } from "./Alliances.vue?vue&type=template&id=743c8b4c&scoped=true"
import script from "./Alliances.vue?vue&type=script&lang=js"
export * from "./Alliances.vue?vue&type=script&lang=js"
import style0 from "./Alliances.vue?vue&type=style&index=0&id=743c8b4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743c8b4c",
  null
  
)

export default component.exports